export const AUTH_CONTAINER_HEIGHT = 793
export const UNKNOWN_ERROR = 'Noe gikk galt. Prøv igjen eller kontakt support@folkeinvest.no'
